import React from 'react';
import { SEOHeadKontakt } from '../components/SEOHeadKontakt';
import { Header } from '../components/Header';
import { HeroKontakt } from '../components/kontakt/HeroKontakt';
import { KontaktOptionen } from '../components/kontakt/KontaktOptionen';
import { KurzErklaertKontakt } from '../components/kontakt/KurzErklaertKontakt';
import { WasBereichalten } from '../components/kontakt/WasBereichalten';
import { NaechsteSchritte } from '../components/kontakt/NaechsteSchritte';
import { BrueckeSeiten } from '../components/kontakt/BrueckeSeiten';
import { FAQKontakt } from '../components/kontakt/FAQKontakt';
import { AbschlussKontakt } from '../components/kontakt/AbschlussKontakt';
import { Footer } from '../components/Footer';
import { MobileStickyCTA } from '../components/MobileStickyCTA';
import { MapPin } from 'lucide-react';

const KontaktPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHeadKontakt />
      <Header />
      <main>
        <HeroKontakt />
        <KontaktOptionen />
        
        {/* Standort-Karte Section */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Unser Standort in Rellingen</h2>
              <p className="text-lg text-gray-600">50 km Radius um Hamburg - Wir kommen zu Ihnen!</p>
            </div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d18687.842286354396!2d9.835837!3d53.651187!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b187930e87138e%3A0x9dd73924e59ff4dd!2sRellingen!5e0!3m2!1sde!2sde!4v1234567890"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Standort Rellingen"
              ></iframe>
            </div>
          </div>
        </section>
        
        <KurzErklaertKontakt />
        <WasBereichalten />
        <NaechsteSchritte />
        <BrueckeSeiten />
        <FAQKontakt />
        <AbschlussKontakt />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
};

export default KontaktPage;